export const replaceBigIntsWithStringsInObject = (
  obj: Record<string, unknown>,
): Record<string, unknown> => {
  return replaceBigIntsWithStrings(obj) as Record<string, unknown>
}

// Recursively replace all bigint values with their string representation
// and leaves other values as-is.
const replaceBigIntsWithStrings = (obj: unknown): unknown => {
  if (obj == null) return obj

  if (typeof obj === 'bigint') {
    return obj.toString()
  }

  if (Array.isArray(obj)) {
    return obj.map(replaceBigIntsWithStrings)
  }

  if (typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        replaceBigIntsWithStrings(value),
      ]),
    )
  }

  return obj
}

export const __testing__ = {
  replaceBigIntsWithStrings,
}
